// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.13 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.-left-44 {
  left: -11rem;
}
.-top-40 {
  top: -10rem;
}
.bottom-\\[-10px\\] {
  bottom: -10px;
}
.left-\\[-20\\%\\] {
  left: -20%;
}
.left-\\[-25\\%\\] {
  left: -25%;
}
.left-\\[85px\\] {
  left: 85px;
}
.right-7 {
  right: 1.75rem;
}
.right-\\[-15\\%\\] {
  right: -15%;
}
.right-\\[-20\\%\\] {
  right: -20%;
}
.right-\\[-25\\%\\] {
  right: -25%;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-10 {
  top: 2.5rem;
}
.top-\\[-10\\%\\] {
  top: -10%;
}
.top-\\[-350\\%\\] {
  top: -350%;
}
.top-\\[-75px\\] {
  top: -75px;
}
.top-\\[101\\%\\] {
  top: 101%;
}
.top-\\[75px\\] {
  top: 75px;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[-1\\] {
  z-index: -1;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-7 {
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-\\[0px\\] {
  margin-bottom: 0px;
}
.mb-\\[10px\\] {
  margin-bottom: 10px;
}
.mb-\\[246px\\] {
  margin-bottom: 246px;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-\\[-5px\\] {
  margin-top: -5px;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[4\\/3\\] {
  aspect-ratio: 4/3;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.h-1 {
  height: 0.25rem;
}
.h-10 {
  height: 2.5rem;
}
.h-32 {
  height: 8rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-\\[100vh\\] {
  height: 100vh;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[175px\\] {
  height: 175px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[210px\\] {
  height: 210px;
}
.h-\\[230px\\] {
  height: 230px;
}
.h-\\[264px\\] {
  height: 264px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[350px\\] {
  height: 350px;
}
.h-\\[380px\\] {
  height: 380px;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[425px\\] {
  height: 425px;
}
.h-\\[450px\\] {
  height: 450px;
}
.h-\\[45px\\] {
  height: 45px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[510px\\] {
  height: 510px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[75px\\] {
  height: 75px;
}
.h-\\[75vh\\] {
  height: 75vh;
}
.h-\\[80vh\\] {
  height: 80vh;
}
.h-\\[85vh\\] {
  height: 85vh;
}
.h-full {
  height: 100%;
}
.h-nonavbarheight {
  height: var(--nonavbarheight);
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-10 {
  width: 2.5rem;
}
.w-2\\/5 {
  width: 40%;
}
.w-3\\/5 {
  width: 60%;
}
.w-4 {
  width: 1rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-7 {
  width: 1.75rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[100vw\\] {
  width: 100vw;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[165px\\] {
  width: 165px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[270px\\] {
  width: 270px;
}
.w-\\[280px\\] {
  width: 280px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[320px\\] {
  width: 320px;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[450px\\] {
  width: 450px;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[75vw\\] {
  width: 75vw;
}
.w-\\[80vw\\] {
  width: 80vw;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[90vw\\] {
  width: 90vw;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.flex-grow {
  flex-grow: 1;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes botAnim {

  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-11px);
  }

  100% {
    transform: translateY(-11px) rotate(135deg);
  }
}
.animate-botAnim {
  animation: botAnim .5s forwards;
}
@keyframes botAnimRev {

  0% {
    transform: translateY(-11px) rotate(135deg);
  }

  50% {
    transform: translateY(-11px);
  }

  100% {
    transform: translateY(0);
  }
}
.animate-botAnimRev {
  animation: botAnimRev .5s forwards;
}
@keyframes change {

  0%, 100% {
    border-radius: 42% 56% 72% 28% / 42% 42% 56% 48%;
  }

  33% {
    border-radius: 72% 28% 48% 48% / 28% 28% 72% 72%;
  }

  66% {
    border-radius: 100% 56% 56% 100% / 100% 100% 56% 56%;
  }
}
.animate-change {
  animation: change 10s linear infinite;
}
@keyframes gradientX {

  0%, 100% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }
}
.animate-gradient-x {
  animation: gradientX 5s ease infinite;
}
@keyframes midAnim {

  0% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    transform: scale(0);
    opacity: 0;
  }
}
.animate-midAnim {
  animation: midAnim .5s forwards;
}
@keyframes midAnimRev {

  0% {
    transform: scale(0);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.animate-midAnimRev {
  animation: midAnimRev .5s forwards;
}
.animate-none {
  animation: none;
}
@keyframes popup {

  from {
    transform: scale(.75);
  }

  to {
    transform: scale(1);
  }
}
.animate-popup {
  animation: popup .2s forwards;
}
@keyframes topAnim {

  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(11px);
  }

  100% {
    transform: translateY(11px) rotate(45deg);
  }
}
.animate-topAnim {
  animation: topAnim .5s forwards;
}
@keyframes topAnimRev {

  0% {
    transform: translateY(11px) rotate(45deg);
  }

  50% {
    transform: translateY(11px);
  }

  100% {
    transform: translateY(0);
  }
}
.animate-topAnimRev {
  animation: topAnimRev .5s forwards;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.list-disc {
  list-style-type: disc;
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-content-center {
  place-content: center;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-\\[10px\\] {
  gap: 10px;
}
.gap-\\[15px\\] {
  gap: 15px;
}
.gap-\\[7px\\] {
  gap: 7px;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-scroll {
  overflow: scroll;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[16px\\] {
  border-radius: 16px;
}
.rounded-\\[50\\%\\] {
  border-radius: 50%;
}
.rounded-customborder {
  border-radius: 42% 56% 72% 28% / 42% 42% 56% 48%;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-b-4 {
  border-bottom-width: 4px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.bg-\\[\\#00000096\\] {
  background-color: #00000096;
}
.bg-\\[\\#00000099\\] {
  background-color: #00000099;
}
.bg-\\[\\#000000d7\\] {
  background-color: #000000d7;
}
.bg-\\[\\#1360A5AB\\] {
  background-color: #1360A5AB;
}
.bg-\\[\\#1360A5B0\\] {
  background-color: #1360A5B0;
}
.bg-\\[\\#1360A5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(19 96 165 / var(--tw-bg-opacity));
}
.bg-\\[\\#1361a5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(19 97 165 / var(--tw-bg-opacity));
}
.bg-\\[\\#1361a5d9\\] {
  background-color: #1361a5d9;
}
.bg-\\[\\#2176c0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(33 118 192 / var(--tw-bg-opacity));
}
.bg-\\[\\#90C3F6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(144 195 246 / var(--tw-bg-opacity));
}
.bg-\\[\\#E0EDFA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 237 250 / var(--tw-bg-opacity));
}
.bg-applybgcolor {
  background-color: var(--applybgcolor);
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.bg-copyrightbgcolor {
  background-color: var(--copyrightbgcolor);
}
.bg-footerbgcolor {
  background-color: var(--footerbgcolor);
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity));
}
.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-gradient-animated {
  background-image: linear-gradient(-70deg, #10518A, #306EA5, #508AC0, #90C3F6);
}
.bg-200 {
  background-size: 200% 200%;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-fill {
  object-fit: fill;
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-\\[14px\\] {
  padding-left: 14px;
  padding-right: 14px;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-\\[14px\\] {
  padding-top: 14px;
  padding-bottom: 14px;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-\\[75px\\] {
  padding-top: 75px;
}
.pt-\\[85px\\] {
  padding-top: 85px;
}
.text-center {
  text-align: center;
}
.text-justify {
  text-align: justify;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.italic {
  font-style: italic;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-\\[30px\\] {
  line-height: 30px;
}
.leading-\\[70px\\] {
  line-height: 70px;
}
.text-\\[\\#1360A5\\] {
  --tw-text-opacity: 1;
  color: rgb(19 96 165 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.no-underline {
  text-decoration-line: none;
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-55 {
  opacity: 0.55;
}
.opacity-65 {
  opacity: 0.65;
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[5px_5px_0_black\\] {
  --tw-shadow: 5px 5px 0 black;
  --tw-shadow-colored: 5px 5px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-boxShadow {
  --tw-shadow: 3px 3px 5px grey;
  --tw-shadow-colored: 3px 3px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-navbarShadow {
  --tw-shadow: 0 1px 5px 1px grey;
  --tw-shadow-colored: 0 1px 5px 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-75 {
  transition-duration: 75ms;
}

:root{
  --width : 1150px;
  --applybgcolor : #1360A5;
  --footerbgcolor : #10518A;
  --copyrightbgcolor : #002749;
  --nonavbarheight : calc(100vh - 75px);
}
*{
  padding : 0;
  margin: 0;
  box-sizing: border-box;
  font-family: 'Bahnschrift';
  scroll-behavior: smooth; /* for smooth scrolling when a component is mounted*/
}
*::-webkit-scrollbar{
  display: none;
}
.show-scrollbar::before{
  content: '';
  position: absolute;
  top: 0;
  left: -2px;
  z-index: 1;
  width: 16px;
  height: 510px;
  background: linear-gradient(to left, transparent, white);
}
.show-scrollbar::after {
  content: "";
  position: absolute;
  right: -2px;
  top: 0;
  z-index: 1;
  height: 510px;
  width: 16px;
  background: linear-gradient(to right, transparent, white);
}
/* for testimonies scrollbar which appear in devices with screen-width 1024px (Laptops) or more*/
@media (min-width: 1024px) {
  .show-scrollbar::-webkit-scrollbar{
  height: 10px;
  display: block;
}
}
::-webkit-scrollbar-track{
  margin-inline: 10px;
  border-radius: 10px;
  background-color: var(--applybgcolor);
}
::-webkit-scrollbar-thumb{
  border: 3px solid var(--applybgcolor);
  border-radius: 10px;
  background-color: #90C3F6;
}
.hover\\:-translate-y-2:hover {
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes gradientX {

  0%, 100% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }
}
.hover\\:animate-gradient-x:hover {
  animation: gradientX 5s ease infinite;
}
.hover\\:cursor-pointer:hover {
  cursor: pointer;
}
.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.hover\\:text-slate-300:hover {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity));
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:shadow-boxShadow:hover {
  --tw-shadow: 3px 3px 5px grey;
  --tw-shadow-colored: 3px 3px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}
.active\\:translate-x-\\[3px\\]:active {
  --tw-translate-x: 3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:translate-y-\\[3px\\]:active {
  --tw-translate-y: 3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:shadow-\\[2px_2px_0_black\\]:active {
  --tw-shadow: 2px 2px 0 black;
  --tw-shadow-colored: 2px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.group:hover .group-hover\\:flex {
  display: flex;
}
.group:hover .group-hover\\:grid {
  display: grid;
}
.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:bg-\\[\\#00000099\\] {
  background-color: #00000099;
}
.group:hover .group-hover\\:text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
@media not all and (min-width: 1024px) {

  .max-lg\\:block {
    display: block;
  }

  .max-lg\\:hidden {
    display: none;
  }

  .max-lg\\:w-\\[65vw\\] {
    width: 65vw;
  }

  .max-lg\\:flex-col {
    flex-direction: column;
  }

  .max-lg\\:flex-col-reverse {
    flex-direction: column-reverse;
  }

  .max-lg\\:items-center {
    align-items: center;
  }
}
@media not all and (min-width: 768px) {

  .max-md\\:left-\\[-15\\%\\] {
    left: -15%;
  }

  .max-md\\:h-\\[1125px\\] {
    height: 1125px;
  }

  .max-md\\:w-\\[400px\\] {
    width: 400px;
  }

  .max-md\\:w-\\[60vw\\] {
    width: 60vw;
  }

  .max-md\\:w-full {
    width: 100%;
  }

  .max-md\\:flex-col {
    flex-direction: column;
  }

  .max-md\\:gap-5 {
    gap: 1.25rem;
  }

  .max-md\\:border-t-4 {
    border-top-width: 4px;
  }

  .max-md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .max-md\\:text-center {
    text-align: center;
  }

  .max-md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .max-md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .group:hover .group-hover\\:max-md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}
@media not all and (min-width: 640px) {

  .max-sm\\:top-\\[45\\%\\] {
    top: 45%;
  }

  .max-sm\\:m-7 {
    margin: 1.75rem;
  }

  .max-sm\\:hidden {
    display: none;
  }

  .max-sm\\:h-\\[180px\\] {
    height: 180px;
  }

  .max-sm\\:h-\\[300px\\] {
    height: 300px;
  }

  .max-sm\\:h-\\[38px\\] {
    height: 38px;
  }

  .max-sm\\:h-\\[400px\\] {
    height: 400px;
  }

  .max-sm\\:h-\\[50px\\] {
    height: 50px;
  }

  .max-sm\\:w-4 {
    width: 1rem;
  }

  .max-sm\\:w-\\[130px\\] {
    width: 130px;
  }

  .max-sm\\:w-\\[250px\\] {
    width: 250px;
  }

  .max-sm\\:w-\\[300px\\] {
    width: 300px;
  }

  .max-sm\\:w-\\[310px\\] {
    width: 310px;
  }

  .max-sm\\:w-\\[400px\\] {
    width: 400px;
  }

  .max-sm\\:w-\\[50px\\] {
    width: 50px;
  }

  .max-sm\\:w-\\[75vw\\] {
    width: 75vw;
  }

  .max-sm\\:w-\\[80vw\\] {
    width: 80vw;
  }

  .max-sm\\:w-\\[90px\\] {
    width: 90px;
  }

  .max-sm\\:flex-col {
    flex-direction: column;
  }

  .max-sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .max-sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .max-sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .max-sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .max-sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .max-sm\\:leading-\\[60px\\] {
    line-height: 60px;
  }
}
@media (min-width: 640px) {

  .sm\\:-left-80 {
    left: -20rem;
  }

  .sm\\:-top-36 {
    top: -9rem;
  }

  .sm\\:m-5 {
    margin: 1.25rem;
  }

  .sm\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .sm\\:w-1\\/2 {
    width: 50%;
  }

  .sm\\:w-72 {
    width: 18rem;
  }

  .sm\\:w-\\[120px\\] {
    width: 120px;
  }

  .sm\\:w-\\[280px\\] {
    width: 280px;
  }

  .sm\\:w-\\[450px\\] {
    width: 450px;
  }

  .sm\\:w-\\[500px\\] {
    width: 500px;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:gap-5 {
    gap: 1.25rem;
  }

  .sm\\:border-l-4 {
    border-left-width: 4px;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 768px) {

  .md\\:hidden {
    display: none;
  }

  .md\\:w-\\[140px\\] {
    width: 140px;
  }

  .md\\:w-\\[300px\\] {
    width: 300px;
  }

  .md\\:w-\\[400px\\] {
    width: 400px;
  }

  .md\\:w-\\[600px\\] {
    width: 600px;
  }

  .md\\:w-\\[900px\\] {
    width: 900px;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }
}
@media (min-width: 1024px) {

  .lg\\:-bottom-\\[10px\\] {
    bottom: -10px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:h-\\[264px\\] {
    height: 264px;
  }

  .lg\\:h-\\[400px\\] {
    height: 400px;
  }

  .lg\\:h-\\[410px\\] {
    height: 410px;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-\\[300px\\] {
    width: 300px;
  }

  .lg\\:w-\\[975px\\] {
    width: 975px;
  }
}
@media (min-width: 1280px) {

  .xl\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .xl\\:mb-0 {
    margin-bottom: 0px;
  }

  .xl\\:mr-16 {
    margin-right: 4rem;
  }

  .xl\\:block {
    display: block;
  }

  .xl\\:flex {
    display: flex;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:h-\\[25px\\] {
    height: 25px;
  }

  .xl\\:h-\\[262px\\] {
    height: 262px;
  }

  .xl\\:h-\\[90px\\] {
    height: 90px;
  }

  .xl\\:w-\\[1050px\\] {
    width: 1050px;
  }

  .xl\\:w-\\[150px\\] {
    width: 150px;
  }

  .xl\\:w-\\[20px\\] {
    width: 20px;
  }

  .xl\\:w-\\[25px\\] {
    width: 25px;
  }

  .xl\\:w-\\[320px\\] {
    width: 320px;
  }

  .xl\\:w-\\[350px\\] {
    width: 350px;
  }

  .xl\\:w-\\[35px\\] {
    width: 35px;
  }

  .xl\\:w-\\[510px\\] {
    width: 510px;
  }

  .xl\\:w-\\[700px\\] {
    width: 700px;
  }

  .xl\\:w-\\[90px\\] {
    width: 90px;
  }

  .xl\\:w-\\[950px\\] {
    width: 950px;
  }

  .xl\\:w-width {
    width: var(--width);
  }

  .xl\\:gap-\\[22\\.5px\\] {
    gap: 22.5px;
  }

  .xl\\:p-0 {
    padding: 0px;
  }

  .xl\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .xl\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .xl\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;;EAAnB;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;;EAAnB;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;EAC5B,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB,EAAE,oDAAoD;AAC/E;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,WAAW;EACX,aAAa;EACb,wDAAwD;AAC1D;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,UAAU;EACV,aAAa;EACb,WAAW;EACX,yDAAyD;AAC3D;AACA,gGAAgG;AAChG;EACE;EACA,YAAY;EACZ,cAAc;AAChB;AACA;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,yBAAyB;AAC3B;AAzDA;EAAA,yBAyDC;EAzDD;AAyDC;AAzDD;EAAA,iBAyDC;EAzDD,iBAyDC;EAzDD;AAyDC;AAzDD;;EAAA;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;AAAA;AAzDD;EAAA;AAyDC;AAzDD;EAAA;AAyDC;AAzDD;EAAA,kBAyDC;EAzDD;AAyDC;AAzDD;EAAA,kBAyDC;EAzDD;AAyDC;AAzDD;EAAA,kBAyDC;EAzDD;AAyDC;AAzDD;EAAA,oBAyDC;EAzDD;AAyDC;AAzDD;EAAA;AAyDC;AAzDD;EAAA,6BAyDC;EAzDD,uDAyDC;EAzDD;AAyDC;AAzDD;EAAA,8BAyDC;EAzDD;AAyDC;AAzDD;EAAA,2GAyDC;EAzDD,yGAyDC;EAzDD;AAyDC;AAzDD;EAAA,oBAyDC;EAzDD;AAyDC;AAzDD;EAAA,qBAyDC;EAzDD;AAyDC;AAzDD;EAAA,qBAyDC;EAzDD;AAyDC;AAzDD;EAAA,4BAyDC;EAzDD,qDAyDC;EAzDD;AAyDC;AAzDD;EAAA;AAyDC;AAzDD;EAAA;AAyDC;AAzDD;EAAA;AAyDC;AAzDD;EAAA,iBAyDC;EAzDD,iBAyDC;EAzDD;AAyDC;AAzDD;EAAA;AAyDC;AAzDD;EAAA,kBAyDC;EAzDD;AAyDC;AAzDD;;EAAA;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;AAAA;AAzDD;;EAAA;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA,qBAyDC;IAzDD;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA,iBAyDC;IAzDD;EAyDC;;EAzDD;IAAA,mBAyDC;IAzDD;EAyDC;;EAzDD;IAAA,mBAyDC;IAzDD;EAyDC;AAAA;AAzDD;;EAAA;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA,oBAyDC;IAzDD;EAyDC;;EAzDD;IAAA,iBAyDC;IAzDD;EAyDC;;EAzDD;IAAA,mBAyDC;IAzDD;EAyDC;;EAzDD;IAAA,mBAyDC;IAzDD;EAyDC;;EAzDD;IAAA,kBAyDC;IAzDD;EAyDC;;EAzDD;IAAA;EAyDC;AAAA;AAzDD;;EAAA;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA,iBAyDC;IAzDD;EAyDC;;EAzDD;IAAA,mBAyDC;IAzDD;EAyDC;;EAzDD;IAAA,kBAyDC;IAzDD;EAyDC;;EAzDD;IAAA,eAyDC;IAzDD;EAyDC;;EAzDD;IAAA,mBAyDC;IAzDD;EAyDC;;EAzDD;IAAA,kBAyDC;IAzDD;EAyDC;AAAA;AAzDD;;EAAA;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA,iBAyDC;IAzDD;EAyDC;;EAzDD;IAAA,eAyDC;IAzDD;EAyDC;AAAA;AAzDD;;EAAA;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;AAAA;AAzDD;;EAAA;IAAA,iBAyDC;IAzDD;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA,iBAyDC;IAzDD;EAyDC;;EAzDD;IAAA;EAyDC;;EAzDD;IAAA,mBAyDC;IAzDD;EAyDC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root{\n  --width : 1150px;\n  --applybgcolor : #1360A5;\n  --footerbgcolor : #10518A;\n  --copyrightbgcolor : #002749;\n  --nonavbarheight : calc(100vh - 75px);\n}\n*{\n  padding : 0;\n  margin: 0;\n  box-sizing: border-box;\n  font-family: 'Bahnschrift';\n  scroll-behavior: smooth; /* for smooth scrolling when a component is mounted*/\n}\n*::-webkit-scrollbar{\n  display: none;\n}\n.show-scrollbar::before{\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -2px;\n  z-index: 1;\n  width: 16px;\n  height: 510px;\n  background: linear-gradient(to left, transparent, white);\n}\n.show-scrollbar::after {\n  content: \"\";\n  position: absolute;\n  right: -2px;\n  top: 0;\n  z-index: 1;\n  height: 510px;\n  width: 16px;\n  background: linear-gradient(to right, transparent, white);\n}\n/* for testimonies scrollbar which appear in devices with screen-width 1024px (Laptops) or more*/\n@media (min-width: 1024px) {\n  .show-scrollbar::-webkit-scrollbar{\n  height: 10px;\n  display: block;\n}\n}\n::-webkit-scrollbar-track{\n  margin-inline: 10px;\n  border-radius: 10px;\n  background-color: var(--applybgcolor);\n}\n::-webkit-scrollbar-thumb{\n  border: 3px solid var(--applybgcolor);\n  border-radius: 10px;\n  background-color: #90C3F6;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
